export default {
      id: "arrow_long_right-usage",
      viewBox: "0 0 62.5 11.5",
      url: __webpack_public_path__ + "sprite.svg#arrow_long_right",
      toString: function () {
        return this.url;
      }
    }